/**
 * 动态加载百度地图api函数
 * @param {String} ak  百度地图AK，必传
 */
 export function loadBMap(ak) {
  return new Promise(function(resolve, reject) {
    if (typeof window.BMapGL !== 'undefined') {
      resolve(window.BMapGL)
      return true
    }
    window.onBMapCallback = function() {
      resolve(window.BMapGL)
    }
    let script = document.createElement('script')
    script.type = 'text/javascript'
    script.src =
      'https://api.map.baidu.com/api?type=webgl&v=1.0&ak=' + ak + '&callback=onBMapCallback'
    script.onerror = reject
    document.head.appendChild(script)
  })
}